<template>
  <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="选择付款节点"
      class="payNodes-edit"
      width="80%"
      top="5vh">
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="payNodes">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="查询">
            <el-input v-model.trim="filter.payNodeName" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="payNodeName" align="center" label="节点名称"/>
      <el-table-column label="操作" align="center" width="120px">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="onSelect(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";


  export default {
    name:"PayNodeSelect",
    components: {VmTable,VmSearch},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        idList: "",
        filter: {
          parentId: "",
          keyWord: "",
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      onSelect(row) {
        this.$emit("select", row);
        this.dialogVisible = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
